/** Created by azhou on 2019/3/26.*/
<template>
  <div>
    <public-title showBack>{{Title.cn}}</public-title>
    <div class="load-area blank_space">
      <div class="d-center" v-if="showMoneyTotal">
        <label>当前查看{{queryCon.storeType == 4 ? '导游' : '门店'}}：{{queryCon.storeName}}</label>
        <label class="ml-auto">实{{traAtour ? '付' : '收'}}金额总计：{{moneyInfo.total_pay_money/100 | formatMoney}}元</label>
        <label class="ml-4" v-if="traAtour">第三方手续费：{{moneyInfo.brokerage_money/100 | formatMoney}}元</label>
      </div>
      <div class="mt-3" v-if="detailType==='1'">
        <el-row class="text-left">
          <el-col :span="homestay ? 8 : 12">
            <span v-if="traAtour">订&nbsp;&nbsp;&nbsp;&nbsp;单&nbsp;&nbsp;&nbsp;号：</span>
            <span v-else>订&nbsp;&nbsp;单&nbsp;&nbsp;号：</span>
            <el-input class="w-70" @focus="serial_hao='';dateintimes='';timestamp=''" size="small" placeholder="订单号" v-model="order_no"/>
          </el-col>
          <el-col :span="homestay ? 8 : 12" class="text-right">
            <span>支付时间：</span>
            <el-date-picker class="w-70" @focus="serial_hao='';dateintimes='';order_no='';" size="small" v-model="timestamp" type="daterange" value-format="timestamp" start-placeholder="开始时间" end-placeholder="结束时间" />
          </el-col>
          <el-col :span="12" class="mt-2" v-if="storeInfo.type == 3">
            <span>入住日期：</span>
            <el-date-picker class="w-70" @focus="timestamp = '';order_no='';serial_hao=''" size="small" v-model="dateintimes" type="daterange" value-format="timestamp" start-placeholder="开始时间" end-placeholder="结束时间" />
          </el-col>
          <el-col :span="12" class="mt-2" v-if="traAtour">
            <span>支付流水号：</span>
            <el-input class="w-70" size="small" @focus="order_no='';dateintimes='';timestamp=''" placeholder="支付平台流水号" v-model="serial_hao"/>
          </el-col>
          <el-col :span="homestay ? 8 : 12" class="text-right" :class="{'mt-2': !homestay}">
            <el-button class="ml-2" type="primary" size="small" @click="searchLists">搜索</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="blank_space">
        <p class="mt-3" v-if="AdminDataLists.total<=0">暂无相关数据</p>
        <div v-else>
          <ul class="list-head mt-3"><li class="w-50" v-for="item in Title.titleArr" :key="item">{{item}}</li></ul>
          <div v-if="detailType === '1'">
            <pay-detail v-for="item in AdminDataLists.lists" :key="item.id" :item="item"/>
          </div>
          <div v-if="detailType === '2'">
            <credit-detail v-for="item in AdminDataLists.lists" :key="item.id" :item="item"/>
          </div>
          <el-pagination background layout="prev, pager, next" class="mt-4"
                        :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                        @current-change="$GFUN.pageChange"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'
  import PayDetail from './PayDetail'
  import CreditDetail from './CreditDetail'

  export default {
    name: 'DetailList',
    components: { CreditDetail, PayDetail },
    data() {
      return {
        moneyInfo:{},
        order_no:'',
        timestamp:'',
        dateintimes: '',
        serial_hao: ''
      }
    },
    computed: {
      ...mapState(['AdminDataLists']),
      ...mapGetters(['storeInfo']),
      //看门店类型是采购商或导游统一判断
      traAtour () { 
        if (this.storeInfo.type == 2 || this.storeInfo.type == 4) return true
        else return false
      },
      homestay () {
        return this.storeInfo.type == 5
      },
      detailType () { return this.$route.query.type  },
      queryCon () { return this.$route.query },
      //搜索条件-开始时间
      startTime() { return this.timestamp ? this.timestamp[0] / 1000 : '' },
      //搜索条件-结束时间
      endTime() { return this.timestamp ? this.timestamp[1] / 1000 + 86399 : '' },
      //入住日期-开始时间
      dateinTime() { return this.dateintimes ? this.dateintimes[0] / 1000 : '' },
      //入住日期-结束时间
      dateoutTime() { return this.dateintimes ? this.dateintimes[1] / 1000 + 86399 : '' },
      showMoneyTotal() {
        return this.detailType === '1';
      },
      Title () {
        switch (this.detailType) {
          case '1':
            let t = this.storeInfo.type;
            let arr;
            if (t == 2 || t == 4) {
              if (t == 4) arr = ['订单号','交易金额','红包抵扣','时间','支付流水号','支付方式','收款方']
              if (t == 2) arr = ['订单号','交易金额','时间','支付流水号','支付方式','收款方']
            } else {
              arr = ['订单号','金额类型','交易金额','红包抵扣','实际打款','时间','支付流水号'];
            }
            
            return {
              cn: '流水明细',
              en: 'payDetail',
              titleArr:arr
            }
          case '2':
            return {
              cn: '积分明细',
              en: 'creditDetail',
              titleArr:['订单号','类型','积分变动','时间','备注']
            }
          default:
            return {}
        }
      }
    },
    watch:{
      'queryCon':'getLists'
    },
    async mounted() {
      this.UPDATECURRENTSTORE({type:Number(this.queryCon.storeType),storeId:this.queryCon.storeId || this.queryCon.store});
      this.getLists();
      if (this.traAtour) this.moneyInfo = await this.getTotalPay();
    },
    destroyed() {
      this.UPDATECURRENTSTORE({type:'',storeId:''});
    },
    methods: {
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getAdminDataLists','getTotalPay','getStoreMoneyLists']),
      async getLists () {
        let data = {}
        switch (this.detailType) {
          case '1':
            data = {
              store_id: this.queryCon.storeId,
              store_type: this.queryCon.storeType,
              order_no:this.order_no,
              adtime:{
                start_time: this.startTime,
                end_time: this.endTime,
              }
            }
            if (this.traAtour) data.trade_no = this.serial_hao;
            else data.money = 'neq_0'
            if (this.storeInfo.type == 3 && this.dateintimes != '') { 
              data.money = ['neq', 0]; data.page = this.queryCon.page;
              data.date_in = {start_time: this.dateinTime, end_time: this.dateoutTime}
            }
            break;
          case '2':
            if (this.traAtour) {
              data = {
                id: this.queryCon.storeId,
              }
            } else {
              data = {
                store_id: this.queryCon.storeId,
                storeType: this.queryCon.storeType
              }
            }
            break;
        }
        let res;
        if (this.dateintimes != '') {
          res = await this.getStoreMoneyLists({ flag: 'all', data, successFun: (res) => {
            this.moneyInfo.total_pay_money = res.total_money
          }});
        } else {
          res = await this.getAdminDataLists({
            type: this.Title.en,
            data,
          })
          if (!this.traAtour) this.$set(this.moneyInfo,'total_pay_money',res.total_money)
        }
      },
      async searchLists() {
        if (this.queryCon.page == 1) this.getLists();
        else this.$router.replace({
          name:this.$route.query.name,
          query:{ ...this.queryCon,page:1 }
        })
        if (this.traAtour) this.moneyInfo = await this.getTotalPay({
          start:this.startTime,
          end:this.endTime,
          trade_no: this.serial_hao
        });
      }
    }
  }
</script>
